import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import common from '../common/index';

const state = {
  addOnGameData: {
    success: false,
    gameId: null,
    correctAnswers: null,
    payOutPoints: 0,
    riskPoints: 0,
  },
  questionsPoints: 0,
  unauthorizedWinnerInfo: {
    msisdn: null,
    prizeId: null,
    name: null,
    existPrize: false,
    gameType: null,
    imageWonUrl: null,
    code: null,
  },
  gameStateEnumForResumeGame: null,
  numberOfQuestionsPerRound: 0,
  transitionOnlyForSearchingToOpponent: false,
  gamePending: false,
  gameInProgress: false,
  gameIsResuming: false,
  gameID: null,
  playersDetails: {
    homePlayerMSISDN: '',
    homePlayerUsername: '',
    homePlayerAvatar: null,
    homePlayerLevel: 0,
    awayPlayerMSISDN: '',
    awayPlayerUsername: '',
    awayPlayerAvatar: null,
  },
  finalRoundNumber: common.state.lastRandomRound,
  currentRoundNumber: 1,
  currentQuestionNumber: 0,
  correctAnswerID: -1,
  currentRoundWinnerMSISDN: '',
  currentRoundWinnerUsername: '',
  gameFinished: false,
  gameWinnerMSISDN: '',
  gameWinnerUsername: '',
  userLeveledUp: false,
  // home player's game data
  homePlayerLevel: 0,
  homePlayerLevelUpBonusPoints: 0,
  homePlayerRoundScore: 0,
  homePlayerRoundAnswerTime: 0,
  homePlayerAnswersPerRound: [],
  homePlayerRoundIsWinner: false,
  homePlayerQuestionDTO: null,
  homePlayerAnswer: '',
  homePlayerQuestionAnswerTime: 0,
  homePlayerCorrectAnswersCSSClasses: [],
  homeCorrectAnswers: 0,
  // home player's post game points
  homePlayerCorrectAnswersPoints: 0,
  homePlayerRoundVictoriesPoints: 0,
  homePlayerGameVictoryPoints: 0,
  homePlayerTotalEarnedPoints: 0,
  homePlayerCurrentLevel: 0,
  homePlayerGameWinsToLevelUp: 0,
  homePlayerGamesWon: 0,
  homePlayerGamesEarned: 0,
  // away player's game data
  awayPlayerLevel: 0,
  awayPlayerRoundScore: 0,
  awayPlayerRoundIsWinner: false,
  awayPlayerAnswer: '',
  awayPlayerQuestionAnswerTime: 0,
  awayCorrectAnswers: 0,
  // away player's post game points
  registrationPoints: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};




// WEBPACK FOOTER //
// ./src/store/modules/game/index.js